import { t } from "../../i18n/translate";
import { $widget } from "@/views/widget/widget";

function getTranslatedLabel(el: Element, defaultValue: string): string {
    const key = el.getAttribute("data-translate") || defaultValue;

    if (!el.hasAttribute("data-translate") && defaultValue) {
        el.setAttribute("data-translate", key);
    }

    return t(key);
}

// Translate an attribute (e.g. aria-label) using its original English value as the
// translation key. The original is preserved in `storeAttr` so re-translation on a
// language switch always starts from the canonical key, not an already-translated value.
function translateAttribute(el: Element, attr: string, storeAttr: string): void {
    const original = el.getAttribute(storeAttr) ?? el.getAttribute(attr) ?? "";
    if (!el.hasAttribute(storeAttr)) {
        el.setAttribute(storeAttr, original);
    }
    if (original) {
        el.setAttribute(attr, t(original));
    }
}

export default function translateWidget($menu: HTMLElement): void {
    $menu.querySelectorAll(".cya11y-card-title, .cya11y-translate").forEach((el) => {
        const text = el.textContent?.trim() || "";
        el.textContent = getTranslatedLabel(el, text);
    });

    if (!$widget) return;

    $widget.querySelectorAll<HTMLElement>("[title]").forEach((el) => {
        const title = el.getAttribute("title") || "";
        el.setAttribute("title", getTranslatedLabel(el, title));
    });

    // Translate aria-label attributes so screen readers announce the localized name.
    $widget.querySelectorAll<HTMLElement>("[aria-label]").forEach((el) => {
        translateAttribute(el, "aria-label", "data-translate-aria");
    });
}